import React from 'react';
import {startJourney} from './lib/journey';
try { startJourney(); } catch { /* Diagnostics must never prevent mounting the app. */ }
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles/index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('SYHouse: #root element not found in index.html');

createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
